// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1U1C-","unreadBadge":"styles_unreadBadge__28NM_","modalContent":"styles_modalContent__1WJp3","modal":"styles_modal__2_bnR"};